import { toRef, computed, resolveComponent, createBlock, openBlock, normalizeProps, guardReactiveProps, unref, createSlots, withCtx, renderSlot, createCommentVNode, createElementBlock, mergeProps, normalizeStyle, normalizeClass, toDisplayString, renderList } from "vue";
import { isNaN } from "lodash-es";
import "../../plugins/apollo.js";
import "moment";
import "../../constants/UserPolicy.js";
import "pinia";
import "../../store/index.js";
import { useI18n } from "../../plugins/i18n.js";
import "../../plugins/banza/img.js";
import "axios";
import "vue-router";
import "maska";
import "../../graphql/queries.js";
import "../../graphql/subscriptions.js";
import "vuetify";
import "vue-social-sharing";
import "@duannx/vue-client-only";
import "vuetify/components/VSnackbar";
import "../../assets/3448554beb4b633a.svg";
import "vuetify/components/VImg";
import "../../constants/components/index.js";
/* empty css                         */
import "vuetify/components/VDialog";
import "../../graphql/mutations.js";
import "sweetalert2";
import "@vee-validate/i18n";
/* empty css                        */
import "vuetify/components/VCard";
import "vuetify/components/VOverlay";
import "vuetify/components/VProgressCircular";
/* empty css                                  */
import "vuetify/components/VDivider";
import "vuetify/components/VList";
import "../../assets/8a32dc557a826bf0.png";
/* empty css               */
import "../../graphql/navigation-menu.js";
import "vuetify/components/VSkeletonLoader";
/* empty css                                 */
import { VBtn } from "vuetify/components/VBtn";
import "vuetify/components/VNavigationDrawer";
import "vuetify/components/VMenu";
import "../Auth/AppleAuthButton/AppleAuthButton.js";
import "../Auth/FacebookAuthButton/FacebookAuthButton.js";
import "../Auth/GoogleAuthButton/GoogleAuthButton.js";
import "../Auth/InstagramAuthButton/InstagramAuthButton.js";
import "../Auth/TelegramAuthButton/TelegramAuthButton.js";
import "vee-validate";
/* empty css                               */
import "vuetify/components/VGrid";
import "./index.js";
import "vuex";
/* empty css                        */
import "vuetify/components/VIcon";
import "vuetify/components/VProgressLinear";
import "vuetify/components/transitions";
import "vue-virtual-scroller";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import "../../icons/mdi/index.js";
/* empty css                            */
import "vuetify/components/VBtnToggle";
import "../../assets/6f5dc1ff0a697731.svg";
import "../../assets/888bb8db73be3c15.svg";
/* empty css                             */
import "vuetify/components/VInfiniteScroll";
/* empty css                                  */
/* empty css                */
import "vuetify/components/VChip";
/* empty css                          */
import "../HtmlEditor/index.js";
import "../Messages/vue-advanced-chat/lib/RoomsList/RoomContent/RoomContent.vue.js";
import "../Messages/vue-advanced-chat/lib/Room/Room.vue.js";
/* empty css                                               */
/* empty css                        */
import "../News/NewsModule/NewsModule.vue.js";
import "../News/NewsModule/NewsList.vue.js";
import "../../graphql/news.js";
/* empty css                  */
import "../Pages/index.js";
import "vue3-runtime-template";
import "ckeditor5/ckeditor5.css";
/* empty css                                 */
import "vuetify/components/VWindow";
import "../../assets/5a0af7dd23957928.png";
import { useTheme } from "../../composables/useTheme.js";
import "tiny-emitter/instance";
import "../../graphql/system-settings.js";
/* empty css                       */
/* empty css                                    */
import "vuetify/components/VHover";
import "../../constants/NewsGroup.js";
/* empty css                                     */
import "vuetify/components/VTabs";
import "vuetify/directives";
import "@iconify/vue";
import "mobile-device-detect";
/* empty css                                   */
import "vuetify/components/VBottomSheet";
import "../../graphql/favorites.js";
import "../../plugins/tracker/page-tracker.js";
/* empty css                             */
import "../../graphql/notifications.js";
/* empty css                                  */
import "../../constants/CommunicationChannels.js";
/* empty css                      */
import "vuetify/components/VColorPicker";
/* empty css                                                */
import "vuetify/components/VTextarea";
/* empty css                      */
import "vuetify/components/VTooltip";
/* empty css                                             */
/* empty css                          */
import "graphql-tag";
import "../../graphql/lookups.js";
import "../../graphql/entity.js";
/* empty css                       */
import "vuetify/components";
/* empty css                             */
/* empty css               */
import "../../graphql/system-events.js";
/* empty css                                        */
/* empty css                   */
/* empty css                         */
import "vuetify/components/VCombobox";
import "vuetify/components/VExpansionPanel";
import "vuetify/components/VTable";
import "../../graphql/files.js";
import "vuetify/components/VForm";
/* empty css                                 */
/* empty css                                               */
import "vuetify/components/VAlert";
/* empty css                                    */
import "vue-dndrop";
/* empty css                                            */
/* empty css                                    */
import "vue-advanced-cropper";
import "../../assets/e94e4817134d7c25.png";
import "vue-advanced-cropper/dist/style.css";
/* empty css                  */
import "vuetify/components/VFileInput";
/* empty css                            */
import "vuetify/components/VAvatar";
/* empty css                                  */
import "vuetify/components/VTextField";
import "vuetify/components/VTimeline";
/* empty css                              */
import "../../graphql/public-articles.js";
/* empty css                                           */
/* empty css                         */
import "vuetify/components/VChipGroup";
import "vuetify/components/VSelect";
import "vuetify/components/VSheet";
/* empty css                            */
import "vuetify/components/VItemGroup";
/* empty css                       */
import "vuetify/components/VCheckbox";
import "vuetify/components/VRadio";
import "vuetify/components/VRadioGroup";
import "cronstrue/i18n";
import "cron-parser";
/* empty css                  */
import "../../graphql/quartz.js";
import "vue-i18n";
import "../../graphql/integration-systems.js";
import "../../constants/IntegrationSystemLogDirection.js";
/* empty css                                                      */
/* empty css                                    */
import "../../graphql/session-store.js";
import "../../composables/useModalPage.js";
import "../../icons/portal/index.js";
const _sfc_main = /* @__PURE__ */ Object.assign({
  inheritAttrs: false
}, {
  __name: "BanzaButton",
  props: {
    preset: {
      type: String,
      default: null
    },
    text: {
      type: String,
      default: null
    },
    settings: {
      type: Object,
      default: null
    },
    iconName: {
      type: String,
      default: null
    },
    iconSize: {
      type: [String, Number],
      default: null
    }
  },
  setup(__props) {
    const { t } = useI18n();
    const props = __props;
    const { preset, attrs } = useTheme({
      componentKey: "BanzaButton",
      presetName: toRef(() => props.preset),
      settings: toRef(() => props.settings)
    });
    const text = computed(() => {
      var _a;
      const { attrs: attrs2, slots } = preset.value || {};
      const value = props.text ?? (attrs2 == null ? void 0 : attrs2.text) ?? ((attrs2 == null ? void 0 : attrs2.textLcz) ? t(attrs2.textLcz) : "");
      if (!value) return null;
      return {
        text: value,
        style: ((_a = slots == null ? void 0 : slots.text) == null ? void 0 : _a.style) ?? {}
      };
    });
    const icon = computed(() => {
      var _a, _b, _c, _d;
      const iconSlot = { ...(_c = (_b = (_a = preset.value) == null ? void 0 : _a.slots) == null ? void 0 : _b.icon) == null ? void 0 : _c.attrs };
      const iconName = props.iconName ?? iconSlot.icon;
      if (!iconName) return null;
      const buttonSize = !isNaN(Number((_d = attrs.value) == null ? void 0 : _d.size)) ? Number(attrs.value.size) : Infinity;
      const iconSize = props.iconSize ?? iconSlot.size ?? Math.min(buttonSize, 24);
      return {
        ...iconSlot,
        icon: iconName,
        size: iconSize
      };
    });
    return (_ctx, _cache) => {
      const _component_b_icon = resolveComponent("b-icon");
      return openBlock(), createBlock(VBtn, normalizeProps(guardReactiveProps(unref(attrs))), createSlots({
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default", {}, () => {
            var _a, _b, _c, _d, _e, _f;
            return [
              ((_a = unref(icon)) == null ? void 0 : _a.icon) && !((_b = unref(icon)) == null ? void 0 : _b.right) ? (openBlock(), createBlock(_component_b_icon, mergeProps({
                key: 0,
                class: unref(text) ? "ml-n1" : ""
              }, unref(icon)), null, 16, ["class"])) : createCommentVNode("", true),
              unref(text) ? (openBlock(), createElementBlock("span", {
                key: 1,
                class: normalizeClass(((_c = unref(icon)) == null ? void 0 : _c.icon) ? ((_d = unref(icon)) == null ? void 0 : _d.right) ? "mr-1" : "ml-1" : ""),
                style: normalizeStyle(unref(text).style)
              }, toDisplayString(unref(text).text), 7)) : createCommentVNode("", true),
              ((_e = unref(icon)) == null ? void 0 : _e.icon) && ((_f = unref(icon)) == null ? void 0 : _f.right) ? (openBlock(), createBlock(_component_b_icon, mergeProps({
                key: 2,
                class: unref(text) ? "mr-n1" : ""
              }, unref(icon)), null, 16, ["class"])) : createCommentVNode("", true)
            ];
          })
        ]),
        _: 2
      }, [
        renderList(_ctx.$slots, (_, slotName) => {
          return {
            name: slotName,
            fn: withCtx((slotProps) => [
              renderSlot(_ctx.$slots, slotName, normalizeProps(guardReactiveProps(slotProps || {})))
            ])
          };
        })
      ]), 1040);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
